<router-outlet />
@if(isLoggedIn | async) {
<app-dashboard-header />
@if(!showDashboardHeader) {
<app-footer />
}
}
@if(commonService.loading()) {
<div id="loading-mask">
    <div id="loading-bar-spinner">
        <div class="spinner-icon"></div>
    </div>
</div>
}
